// extracted by mini-css-extract-plugin
export default {"tmpl-tab-ul":"Edit_tmpl-tab-ul__2YwPK","action-icon":"Edit_action-icon__QRnh0"};